<template>
    <div class="list">
        游戏价格(RMB)：
        <el-input-number v-model="num" @change="handleChange" :min="1" label="描述文字"></el-input-number>
        <el-button class="edit_button" type="primary" icon="el-icon-edit" circle @click="handleConfirmClick"></el-button>
    </div>
</template>

<script>
    import litable from '@/components/li-table'
    import {
        mapState,
        // mapMutations,
        mapActions
    } from 'vuex'
    export default {
        data() {
            return {
                num: null
            }
        },
        async created() {
    
        },
        mounted() {
            this.$axios({
                method: 'GET',
                url: 'http://mp.zizhushizi.com/game-dev/wechat/pay/price'
            }).then(res => {
                this.num = res.data.data
            })
        },
        methods: {
            ...mapActions('students', ['SET_PRICE_CONFIG']),
            handleConfirmClick() {
                this.SET_PRICE_CONFIG(this.num)
            }
        },
        computed: {},
        components: {}
    }
</script>

<style lang="scss" scoped>
    .edit_button {
        margin: 0 20px;
    }
</style>
